exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-header {\n  display: flex;\n  margin-bottom: var(--spacing-default);\n}\n\n.app-header span {\n  width: 40%;\n  margin-left: var(--spacing-default);\n}\n", ""]);

// exports
